export let words: any = {
  // login screen
  login_to_continue: "تسجيل الدخول للمتابعة",
  login: "تسجيل الدخول",
  your_email: "بريدك الإلكتروني",
  Password: "كلمة المرور",
  or: "أو",
  forget_password: "نسيت كلمة المرور",
  login_with_number: "تسجيل الدخول برقم الهاتف",
  login_with_apple: "تسجيل الدخول باستخدام Apple",
  login_with_google: "تسجيل الدخول باستخدام Google",
  dont_have_a_account: "ليس لديك حساب؟",
  register: "تسجيل",
  skip_for_now: "تخطي الآن",
  invalidEmailAddress: "عنوان البريد الإلكتروني غير صالح",
  emailIsRequired: "البريد الإلكتروني مطلوب",
  passwordIsRequired: "كلمة المرور مطلوبة",
  conPasswordIsRequired: "تأكيد كلمة المرور مطلوب",
  fullIsRequired: "الاسم الكامل مطلوب",
  lastIsRequired: "اسم العائلة مطلوب",
  contactIsRequired: "رقم الاتصال مطلوب",
  forgot_password_with_mark: "پاس ورڈ بھول گئے؟",
  enter_your_email_to_reset:
    "اپنا ای میل ایڈریس درج کریں اور ہم آپ کو آپ کے ای میل ایڈریس پر پاس ورڈ ری سیٹ کرنے کا لنک بھیجیں گے۔",
  send_link: "لنک بھیجیں۔",

  // mobile number screen
  back: "رجوع",
  enter_mobile_number: "أدخل رقم الهاتف المحمول",
  mobile_number: "رقم الهاتف المحمول",
  by_continuing_you_agree:
    "بالاستمرار، فإنك توافق على الشروط والأحكام الخاصة بنا",
  continue: "متابعة",

  // otp screen
  please_enter_otp: "يرجى إدخال رمز OTP المكون من 4 أرقام المرسل إلى",
  didnt_receive_otp: "لم تتلقَ رمز OTP؟",
  resend: "إعادة الإرسال",
  otp_verification: "التحقق من OTP",
  confirm: "يتأكد",

  // register screen
  full_name: "الاسم الكامل",
  last_name: "اسم العائلة",
  first_name: "الاسم الأول",
  contact_number: "رقم الاتصال",
  email: "البريد الإلكتروني",
  password: "كلمة المرور",
  password_again: "تأكيد كلمة المرور",
  i_have_read_term: "لقد قرأت وأقر بجميع",
  terms_and_policies: "الشروط والسياسات",
  already_have_acc: "لديك حساب بالفعل؟",
  sign_in: "تسجيل الدخول",
  sign_up: "إنشاء حساب",

  // home screen
  al_baqarah: "البقرة",
  juz_1: "الجزء 1",
  nov_1_vers: "نوفمبر 1 . الآية 7 ، مكية",
  bookmark: "إشارة مرجعية",
  index: "فهرس",
  notes: "ملاحظات",
  Baqarah: "البقرة 8",
  Seen: "الآن",
  remove: "إزالة",
  Enter: "أدخل النص",
  Save: "حفظ الإعدادات",
  ayat: "مرحبا أنا معظم هنا مرحبا أنا معظم هنا مرحبا",
  addNote: "إضافة ملاحظة",
  fetchData: "جلب بيانات القرآن",
  bookmarks: "الإشارات المرجعية",
  popular_qari: "قاري شعبي",
  evening_azkar: "أذكار المساء",
  morning_azkar: "أذكار الصباح",
  afternoon_azkar: "مساء الخير",
  azkar: "أذكار",

  // sidebar
  juz1: "الجزء 1",
  juz2: "الجزء 2",
  juz3: "الجزء 3",
  edit_profile: "تعديل الملف الشخصي",
  logout: "تسجيل الخروج",
  quick_setting: "الإعداد السريع",
  language: "اللغة",
  english: "الإنجليزية",
  arabic: "العربية",
  font_size: "حجم الخط",
  al_fatihah: "الفاتحة",
  search_: "...بحث",
  notFound: "غير موجود",
  searchText: "ابحث أولاً",
  theme: "السمة",
  light: "فاتح",
  dark: "داكن",
  juz: "جزء",
  surahs: "سور",
  font_preference: "تفضيلات الخط",
  send_feedback: "إرسال الملاحظات",

  // toast messages
  userNotFount: "المستخدم غير موجود",
  numberNotFount: "الرقم غير موجود",
  numberRequired: "حقل الرقم مطلوب",
  noteRequired: "حقل الملاحظة مطلوب",
  numberOrEmail: "الرقم أو البريد الإلكتروني موجود بالفعل",
  someThing: "حدث خطأ ما",
  otpVerficationReq: "مطلوب OTP للتحقق",
  verificationFail: "فشل التحقق",
  loginFirst: "تسجيل الدخول مطلوب للمتابعة",
  alert: "تنبيه",
  loginRequire: "تسجيل الدخول مطلوب لهذه الميزة",
  alreadyBook: "تم الإشارة إليه بالفعل",
  alreadySaved: "تم الحفظ بالفعل",
  bookSave: "تم حفظ الإشارة المرجعية",
  notsSave: "تم حفظ الملاحظات",
  notsReq: "الملاحظات مطلوبة",
  otpNotMatch: "رمز OTP غير مطابق",
  not_connect: "لا يوجد اتصال بالإنترنت",
  not_connect_req: "يتطلب اتصال بالإنترنت",
  profile_updated: "پروفائل کامیابی کے ساتھ اپ ڈیٹ ہو گیا۔",
  login_success: "تم تسجيل الدخول بنجاح",
  resgister_success: "تم تسجيل الدخول بنجاح",

  //search
  search_qari: "بحث قاري",
  type_here: "تاي هنا",

  // tabs
  home: "بيت",
  search: "يبحث",
  radio: "راديو",
  settings: "إعدادات",
  downloaded: "تم التنزيل",

  // radio
  now_listing: "القائمة الآن",
  popular_radio: "الراديو الشعبي",
  al_quran_radio: "إذاعة القرآن الكريم",

  //verse screen
  madaniyah: "مدنية",
  makkiyah: "مكية",
  verse: "الآية",
  no: "لا",

  // notes
  font_size_note: "سيظهر التغيير في: الإشعارات، والترجمات، وبطاقات المعلومات.",
  save: "يحفظ",
  cancel: "يلغي",
  skip: "تخطي الآن",
  empty_data: "البيانات فارغة",
  al_quran_audio: "القران الكريم صوت",
  al_quran_pro: "موقع القرآن الكريم",
};
